"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProgressBarContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProgressBarContainer = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .progress-bar-box {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    background-color: ${ui_components_1.baseColors.background000};
    display: flex;
    padding: ${({ theme }) => theme.spacing(2)};
    gap: ${({ theme }) => theme.spacing(2)};
    width: 450px;

    .progress-bar {
      border-radius: 4px;
      height: 6px;
    }
  }
`;
